module.exports = __webpack_public_path__ + "img/IMG_2399_T_L_Black_MockedUp.cabaa6cd.jpg";